import { css } from "@compiled/react";

import { useProductKeys } from "../../../hooks";
import { ProductKeyType } from "../../../models";

import { ProductTipListItem } from "./product-list-item";

const productTipListStyle = css({
    "listStyle": "none",
    "margin": 0,
    "padding": 0,

    "li:first-of-type": {
        marginBlockStart: 0
    }
});

export const ProductTipList = () => {
    const productKeys = useProductKeys();
    return (
        <ul css={productTipListStyle}>
            {productKeys.map((productKey: ProductKeyType) => (
                <ProductTipListItem key={productKey} productKey={productKey} />
            ))}
        </ul>
    );
};
